export default "__VITE_ASSET__DqichMMK__"